module.exports = __webpack_public_path__ + "static/img/gotomag.20d1e115.png";